import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a20591c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "категории", -1))
const _hoisted_2 = { class: "categories-content" }

import CategoryItem from './CategoryItem.vue'
    import type {Ref} from 'vue'
    import { ref, computed, onMounted} from 'vue'
    // import { getCategories, getProductByCategoryId } from './getProductsData'
    import {API} from '@/api/modules/productData'
    import handleError from '@/tools/errorHandler'

    import ButtonCustom from '../UI/ButtonCustom.vue'
    import { useStore } from 'vuex'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CategoriesSideBar',
  setup(__props) {

    const store = useStore()

    // запрос по дефолту

    let categories:Ref<Array<any>> = ref([])

    async function getCategories () {
        try {
            let res = await API.getCategories()
            categories.value = res.data
        } catch (err) {
            handleError(err)
        }
    }

    onMounted(()=>{
        let id = 1
        if(localStorage.getItem('series') != null){
            id = Number(localStorage.getItem('series'))
            localStorage.removeItem('series')
        }
        getProductsByCategoty(id)
        getCategories()
    })

    async function getProductsByCategoty(id:number) {
        let res = await API.getProductByCategory(id)
        let products = res.data
        store.commit('products', products)
    }

    // function getProductByCatId(id:number) :void{
    //     // запрашиваем Products по category id
    //     let products = getProductByCategoryId(id)
    //     store.commit('products', products)
    // }

    // Отображение категорий

    function showCategories(){
        let element :Ref<Element | null> = ref(document.querySelector('.categories-content'))

        if(element.value != null){
            element.value.classList.toggle("active")
        }
    }

    let buttonClicked = ref(false)

    let buttonText = computed(() => {
        if(buttonClicked.value){
            return 'Скрыть категории'
        } else {
            return 'Показать категории'
        }
    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CategoryItem, {
        categories: _unref(categories),
        onSelected: getProductsByCategoty,
        treeStyle: 0
      }, null, 8, ["categories"])
    ]),
    _createVNode(ButtonCustom, {
      class: "show-cat-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => {showCategories(); _isRef(buttonClicked) //@ts-ignore
 ? buttonClicked.value = !_unref(buttonClicked) : buttonClicked = !_unref(buttonClicked)})
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(buttonText)), 1)
      ]),
      _: 1
    })
  ]))
}
}

})